import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import userAvatar from "../assets/img/img1.jpg";
import {
  adminMenu,
  executiveMenu,
  teachingMenu,
  dashboardMenu,
  applicationsMenu,
  pagesMenu,
  uiElementsMenu,
  advisorMenu,
  manageTeachingMenu,
  registrationMenu,
  headOfGeneralAcademicMenu,
  levelHeadMenu,
  libraryMenu,
  dormitoryMenu,
  disciplineMenu,
  bankMenu,
  feeMenu,
  hrMenu,
  hrSelfMenu,
  adminOfficeMenu,
  adminOfficeSelfMenu,
  inventoryMenu,
  supplyMenu,
  assessmentMenu,
  islamicRegistrationMenu,
  islamicTeachingMenu,
  islamicAssessmentMenu,
  islamicAdvisorMenu,
  islamicManageTeachingMenu,
  studentSearchMenu,
  generalMenu,
  issueReportingMenu,
  issueReportingAdminMenu,
} from "../data/Menu";

import { getFullName, getPosName, getUser, logout } from "../services/authorize";
import { useAuth } from "../services/authProvider";

const UPLOAD_BASE = (process.env.REACT_APP_API || "http://localhost:3002/api")
  .replace(/\/api\/?$/, "")
  .replace(/\/$/, "");

const resolveUploadUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${UPLOAD_BASE}${path.startsWith("/") ? path : `/${path}`}`;
};

export default function Sidebar () {
  const scrollBarRef = React.useRef(null);
  const avatarSrc = resolveUploadUrl(getUser()?.t_photo) || userAvatar;

  const toggleFooterMenu = (e) => {
    e.preventDefault();
    let parent = e.target.closest(".sidebar");
    parent.classList.toggle("footer-menu-show");
  };

  // Close the footer menu when navigating (no preventDefault so the Link still routes)
  const closeFooterMenu = (e) => {
    const parent = e.currentTarget.closest(".sidebar");
    if (parent) parent.classList.remove("footer-menu-show");
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <Link to="/" className="sidebar-logo">
          SIS WTI
        </Link>
      </div>
      <PerfectScrollbar
        className="sidebar-body"
        ref={scrollBarRef}
      >
        <SidebarMenu onUpdateSize={() => scrollBarRef.current && scrollBarRef.current.updateScroll()} />
      </PerfectScrollbar>
      <div className="sidebar-footer">
        <div className="sidebar-footer-top">
          <div className="sidebar-footer-thumb">
            <img src={avatarSrc} alt="" />
          </div>
          <div className="sidebar-footer-body">
            <h6>
              <Link to="/account/profile">{getFullName()}</Link>
            </h6>
            <p>{getPosName()}</p>
          </div>
          <Link
            onClick={toggleFooterMenu}
            to=""
            className="dropdown-link"
          >
            <i className="ri-arrow-down-s-line"></i>
          </Link>
        </div>
        <div className="sidebar-footer-menu">
          <nav className="nav">
            <Link to="/account/profile/edit" onClick={closeFooterMenu}>
              <i className="ri-edit-2-line"></i> แก้ไขข้อมูลส่วนตัว
            </Link>
            <Link to="/account/profile" onClick={closeFooterMenu}>
              <i className="ri-profile-line"></i> ดูโปรไฟล์
            </Link>
          </nav>
          <hr />
          <nav className="nav">
            <Link to="/general/help" onClick={closeFooterMenu}>
              <i className="ri-question-line"></i> ศูนย์ช่วยเหลือ
            </Link>
            <Link to="/pages/change-password" onClick={closeFooterMenu}>
              <i className="ri-lock-line"></i> เปลี่ยนรหัสผ่าน
            </Link>
            <Link to="/account/settings" onClick={closeFooterMenu}>
              <i className="ri-user-settings-line"></i> การตั้งค่าบัญชี
            </Link>
            <Link to="" onClick={() => logout(() => window.location.reload())}>
              <i className="ri-logout-box-r-line"></i> ออกจากระบบ
            </Link>
          </nav>
        </div>
      </div>
    </div>
  );
}

function useIsRtl() {
  const [isRtl, setIsRtl] = useState(
    () => document.documentElement.getAttribute('dir') === 'rtl'
  );
  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsRtl(document.documentElement.getAttribute('dir') === 'rtl');
    });
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['dir'] });
    return () => observer.disconnect();
  }, []);
  return isRtl;
}

function SidebarMenu(props) {
  const isRtl = useIsRtl();

  // Helper to toggle menu group
  const toggleMenu = (e) => {
    e.preventDefault();
    let parent = e.target.closest(".nav-group");
    parent.classList.toggle("show");
    if (props.onUpdateSize) props.onUpdateSize();
  };

  // Helper to toggle submenu while closing siblings' submenu
  const toggleSubMenu = (e) => {
    e.preventDefault();
    let parent = e.target.closest(".nav-item");
    let node = parent.parentNode.firstChild;
    while (node) {
      if (node !== parent && node.nodeType === Node.ELEMENT_NODE)
        node.classList.remove("show");
      node = node.nextElementSibling || node.nextSibling;
    }
    parent.classList.toggle("show");
    if (props.onUpdateSize) props.onUpdateSize();
  };

  // Helper to render menu
  const populateMenu = (m, useAr = false) => {
    const menu = m.map((m, key) => {
      const displayLabel = (useAr && m.labelJawi) ? m.labelJawi : m.label;
      let sm;
      if (m.submenu) {
        sm = m.submenu.map((sm, key) => {
          const subLabel = (useAr && sm.labelJawi) ? sm.labelJawi : sm.label;
          return (
            <NavLink to={sm.link} className="nav-sub-link" key={key}>
              {subLabel}
            </NavLink>
          );
        });
      }

      return (
        <li key={key} className="nav-item">
          {!sm ? (
            <NavLink to={m.link} className="nav-link">
              <i className={m.icon}></i> <span>{displayLabel}</span>
            </NavLink>
          ) : (
            <div onClick={toggleSubMenu} className="nav-link has-sub">
              <i className={m.icon}></i> <span>{displayLabel}</span>
            </div>
          )}
          {m.submenu && <nav className="nav nav-sub">{sm}</nav>}
        </li>
      );
    });

    return <ul className="nav nav-sidebar">{menu}</ul>;
  };

  const { posIds } = useAuth()
  const userPositions = posIds && posIds.length > 0 ? posIds : [1]

  return (
    <React.Fragment>
      {/* ข้อมูลนักเรียน — ทุกคนที่ล็อกอินเข้าถึงได้ */}
      <div className="nav-group show">
        <div className="nav-label" onClick={toggleMenu}>
          ข้อมูลนักเรียน
        </div>
        {populateMenu(studentSearchMenu)}
      </div>

      {(userPositions.includes(90) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ผู้บริหาร
          </div>
          {populateMenu(executiveMenu)}
        </div>
      )}

      {userPositions.includes(1) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ข้อมูลการสอน
          </div>
          {populateMenu(teachingMenu)}
        </div>
      )}
      {userPositions.includes(2) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ข้อมูลประจำชั้น
          </div>
          {populateMenu(advisorMenu)}
        </div>
      )}
      {(userPositions.includes(5) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ข้อมูลการเรียนการสอน
          </div>
          {populateMenu(manageTeachingMenu)}
        </div>
      )}

      {/* ข้อมูลบุคลากรของฉัน — ทุกคนเข้าถึงได้ (ไม่จำกัดตำแหน่ง) */}
      <div className="nav-group show">
        <div className="nav-label" onClick={toggleMenu}>
          ข้อมูลบุคลากรของฉัน
        </div>
        {populateMenu(hrSelfMenu)}
        {populateMenu(adminOfficeSelfMenu)}
      </div>

      {/* Head of general academic menu for positions 3, 4, 17, and 99*/}
      {(userPositions.includes(3) || userPositions.includes(4) || userPositions.includes(17) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            หัวหน้าวิชาการสามัญ
          </div>
          {populateMenu(headOfGeneralAcademicMenu)}
        </div>
      )}

      {/* หัวหน้าระดับชั้น — ม.ต้น (21) / ม.ปลาย (22); ข้อมูลกรองตามระดับที่ backend.
          admin (99) เข้าถึง 5 หน้านี้ได้อยู่แล้วผ่านเมนู "หัวหน้าวิชาการสามัญ" จึงไม่แสดงเมนูซ้ำ */}
      {(userPositions.includes(21) || userPositions.includes(22)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            {userPositions.includes(21) ? "หัวหน้าระดับ ม.ต้น" : "หัวหน้าระดับ ม.ปลาย"}
          </div>
          {populateMenu(levelHeadMenu)}
        </div>
      )}

      {/* Registration menu for positions 8, 9, and 99 */}
      {(userPositions.includes(8) || userPositions.includes(9) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ทะเบียนและหลักสูตร
          </div>
          {populateMenu(registrationMenu)}
        </div>
      )}

      {/* Assessment menu for positions 10, 11, and 99 */}
      {(userPositions.includes(10) || userPositions.includes(11) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ฝ่ายวัดผลและประเมินผล
          </div>
          {populateMenu(assessmentMenu)}
        </div>
      )}

      {/* Library menu for positions 3, 4, 17, 18 and 99 */}
      {(userPositions.includes(13) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ห้องสมุด
          </div>
          {populateMenu(libraryMenu)}
        </div>
      )}

      {/* Dormitory menu for positions 99 and 17 */}
      {(userPositions.includes(99) || userPositions.includes(17)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            หอพัก
          </div>
          {populateMenu(dormitoryMenu)}
        </div>
      )}

      {(userPositions.includes(99) || userPositions.includes(16)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ฝ่ายปกครอง
          </div>
          {populateMenu(disciplineMenu)}
        </div>
      )}

      {(userPositions.includes(18) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ธนาคารนักเรียน
          </div>
          {populateMenu(bankMenu)}
        </div>
      )}

      {/* Fee / finance menu for positions 25 and 99 */}
      {(userPositions.includes(25) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            การเงิน / ค่าใช้จ่ายนักเรียน
          </div>
          {populateMenu(feeMenu)}
        </div>
      )}

      {/* HR menu for positions 20 and 99 */}
      {(userPositions.includes(20) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            งานบุคลากร
          </div>
          {populateMenu(hrMenu)}
        </div>
      )}

      {/* Admin Office menu for positions 23 and 99 */}
      {(userPositions.includes(23) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            งานธุรการ
          </div>
          {populateMenu(adminOfficeMenu)}
        </div>
      )}

      {/* งานพัสดุ/วัสดุ — พัสดุ (19), ธุรการ (23, งานพัสดุเป็นส่วนหนึ่งของธุรการ) และ admin (99) */}
      {(userPositions.includes(19) || userPositions.includes(23) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            งานพัสดุครุภัณฑ์
          </div>
          {populateMenu(inventoryMenu)}
        </div>
      )}

      {(userPositions.includes(19) || userPositions.includes(23) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            วัสดุและของใช้
          </div>
          {populateMenu(supplyMenu)}
        </div>
      )}

      {/* Islamic Teaching menu (pos 50, 99) */}
      {(userPositions.includes(50) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            {isRtl ? 'تدريس القسم الديني' : 'การสอนภาคศาสนา'}
          </div>
          {populateMenu(islamicTeachingMenu, isRtl)}
        </div>
      )}

      {/* Islamic Advisor menu (pos 51, 99) */}
      {(userPositions.includes(51) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            {isRtl ? 'وكيل صف القسم الديني' : 'ที่ปรึกษาห้องภาคศาสนา'}
          </div>
          {populateMenu(islamicAdvisorMenu, isRtl)}
        </div>
      )}

      {/* Islamic Assessment menu (pos 52, 99) */}
      {(userPositions.includes(52) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            {isRtl ? 'تقييم القسم الديني' : 'วัดผลภาคศาสนา'}
          </div>
          {populateMenu(islamicAssessmentMenu, isRtl)}
        </div>
      )}

      {/* Islamic Registration menu (pos 52, 99) */}
      {(userPositions.includes(52) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            {isRtl ? 'بهاݢين ڤندافتارن اݢام' : 'ทะเบียนภาคศาสนา'}
          </div>
          {populateMenu(islamicRegistrationMenu, isRtl)}
        </div>
      )}

      {/* Islamic Manage Teaching menu (pos 53, 99) */}
      {(userPositions.includes(53) || userPositions.includes(99)) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            {isRtl ? 'ڬلوله ڤڠاجارن اڬام' : 'จัดการการสอนภาคศาสนา'}
          </div>
          {populateMenu(islamicManageTeachingMenu, isRtl)}
        </div>
      )}

      {/* Admin menu (pos 99 only) */}
      {userPositions.includes(99) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            ผู้ดูแลระบบ
          </div>
          {populateMenu(adminMenu)}
        </div>
      )}

      {/* เมนูทั่วไป — ทุกคนเข้าถึงได้ (ไม่จำกัดตำแหน่ง) */}
      <div className="nav-group show">
        <div className="nav-label" onClick={toggleMenu}>
          ทั่วไป
        </div>
        {populateMenu(generalMenu)}
      </div>

      {/* แจ้งปัญหา / แจ้งซ่อม — ทุกคนเข้าถึงได้ */}
      <div className="nav-group show">
        <div className="nav-label" onClick={toggleMenu}>
          แจ้งปัญหา / แจ้งซ่อม
        </div>
        {populateMenu(issueReportingMenu)}
      </div>

      {/* จัดการระบบแจ้งปัญหา — admin (pos 99) เท่านั้น */}
      {userPositions.includes(99) && (
        <div className="nav-group show">
          <div className="nav-label" onClick={toggleMenu}>
            จัดการระบบแจ้งปัญหา
          </div>
          {populateMenu(issueReportingAdminMenu)}
        </div>
      )}

      {/* Menu from original template */}
      {/* <div className="nav-group show">
        <div className="nav-label" onClick={toggleMenu}>
          Dashboard
        </div>
        {populateMenu(dashboardMenu)}
      </div>
      <div className="nav-group show">
        <div className="nav-label" onClick={toggleMenu}>
          Applications
        </div>
        {populateMenu(applicationsMenu)}
      </div>
      <div className="nav-group show">
        <div className="nav-label" onClick={toggleMenu}>
          Pages
        </div>
        {populateMenu(pagesMenu)}
      </div>
      <div className="nav-group show">
        <div className="nav-label" onClick={toggleMenu}>
          UI Elements
        </div>
        {populateMenu(uiElementsMenu)}
      </div> */}
    </React.Fragment>
  );
}

window.addEventListener("click", function (e) {
  // Close sidebar footer menu when clicked outside of it
  let tar = e.target;
  let sidebar = document.querySelector(".sidebar");
  if (!tar.closest(".sidebar-footer") && sidebar) {
    sidebar.classList.remove("footer-menu-show");
  }

  // Hide sidebar offset when clicked outside of sidebar
  if (!tar.closest(".sidebar") && !tar.closest(".menu-link")) {
    document.querySelector("body").classList.remove("sidebar-show");
  }
});

window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("sidebar-skin");
  let HTMLTag = document.querySelector("html");

  if (skinMode) {
    HTMLTag.setAttribute("data-sidebar", skinMode);
  }
});
